import { render, staticRenderFns } from "./ModalShippingCompany.vue?vue&type=template&id=57488b97&scoped=true&"
import script from "./ModalShippingCompany.vue?vue&type=script&lang=js&"
export * from "./ModalShippingCompany.vue?vue&type=script&lang=js&"
import style0 from "./ModalShippingCompany.vue?vue&type=style&index=0&id=57488b97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57488b97",
  null
  
)

export default component.exports